/**
 * @generated SignedSource<<cec8170dddb5229092a669b9eaa06e74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiteNav_viewer$data = {
  readonly navigation: {
    readonly modules: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SiteNavItem_navigationModule">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "SiteNav_viewer";
};
export type SiteNav_viewer$key = {
  readonly " $data"?: SiteNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "previewKey"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNav_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "previewKey"
        }
      ],
      "concreteType": "Navigation",
      "kind": "LinkedField",
      "name": "navigation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavigationModule",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SiteNavItem_navigationModule"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0ca62205dba26f7abb8476a182375c19";

export default node;
